import React from 'react';
import { Box, CircularProgress } from '@mui/material';

interface TableLoaderProps {
  size?: number;
  thickness?: number;
  message?: string;
  minHeight?: number;
}

const TableLoader: React.FC<TableLoaderProps> = ({ size = 42, thickness = 3, message = 'Loading...', minHeight = 200 }) => (
  <Box sx={{
    width: '100%',
    minHeight,
    position: 'relative',
  }}>
    <Box sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2,
    }}>
      <CircularProgress size={size} thickness={thickness} />
      <Box sx={{ fontSize: 15, fontWeight: 500, mt: 1 }}>{message}</Box>
    </Box>
  </Box>
);

export default TableLoader;
